export enum ContractType {
  Funded = 'funded',
  FundedRules = 'funded-rules',
  Affiliation = 'affiliation',
  Nyse = 'nyse',
  Mini = 'mini',
  Micro = 'micro',
}

export enum ContractStatus {
  Requested = 'requested',
  Signed = 'signed',
}

export interface Contract {
  type: ContractType;
  userId: string;
  status: ContractStatus;
  version: number;
  data?: ContractData;
  updatedAt?: Date;
}

export type NyseContractData = {
  firstAgreement: boolean;
  receiveDataNonBusinessUse: boolean;
  hasSECOrCFTC: boolean;
  securityAgency: boolean;
  similarToSECOrCFTC: boolean;
  investmentAdvices: boolean;
  assetManager: boolean;
  usingOtherCapital: boolean;
  tradeForOtherCorpOrOther: boolean;
  sharingProfit: boolean;
  sharingSpace: boolean;
  firstName: string;
  lastName: string;
  address: string;
  occupations: string;
  companyName: string;
  employer: string;
  employerAddress: string;
  title: string;
  signThatProvidedDataIsCorrect: boolean;
  finalAgreement: boolean;
};

export type ContractData = NyseContractData;
